<template>
  <a-drawer
    :maskClosable="false"
    width="80%"
    :visible="open"
    :destroyOnClose="true"
    @close="onCloseConfirm(() => (open = false))"
  >
    <a-divider orientation="left"><b>{{ formTitle }}</b></a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />

    <div class="layout-container">
      <div class="setting-panel">
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-form-model-item label="名称" prop="name">
            <a-input v-model="form.name" placeholder="请输入名称" show-count :maxLength="36" />
          </a-form-model-item>
          <a-form-model-item label="是否开启" prop="status">
            <a-radio-group v-model="form.status" button-style="solid">
              <a-radio-button :value="0">禁用</a-radio-button>
              <a-radio-button :value="1">开启</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="类目图标" prop="icon">
            <file-upload
              type="image"
              :count="1"
              :isUpload="false"
              autoCropWidth="80"
              autoCropHeight="80"
              :defaultList="form.icon ? [form.icon] : []"
              :file="form.icon"
              @input="getImg($event, 'icon')"
            />
          </a-form-model-item>
          <a-form-model-item label="跳转类型" prop="jumpType">
            <a-radio-group v-model="form.jumpType" button-style="solid" @change="handleJumpTypeChange">
              <a-radio-button :value="0">维修产品</a-radio-button>
              <!-- <a-radio-button :value="1">服务分类</a-radio-button>
              <a-radio-button :value="2">预约施压单</a-radio-button>
              <a-radio-button :value="3">优惠券</a-radio-button>
              <a-radio-button :value="4">人工客服</a-radio-button> -->
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item v-if="form.jumpType === 0" label="关联产品" prop="prodId">
            <a-button v-if="!selectedProd" type="dashed" icon="plus" style="width: 100%" @click="handlePick">选择维修产品</a-button>
            <a-tag v-else closable @close="clearProd" style="font-size: 14px; padding: 4px 8px">{{ selectedProd.prodName }}</a-tag>
          </a-form-model-item>

          <a-form-model-item v-if="form.jumpType === 1" label="服务分类" prop="serviceId">
            <a-button v-if="!selectedService" type="dashed" icon="plus" style="width: 100%" @click="handlePickService">选择服务分类</a-button>
            <a-tag v-else closable @close="clearService" style="font-size: 14px; padding: 4px 8px">{{ selectedService.categoryName }}</a-tag>
          </a-form-model-item>

          <a-form-model-item label="首页布局" prop="type">
            <a-radio-group v-model="form.type" button-style="solid">
              <a-radio-button :value="0">上部</a-radio-button>
              <a-radio-button :value="1">中部</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="排序" prop="sort">
            <a-input v-model="form.sort" placeholder="0-9999" :maxLength="4" @input="form.sort = form.sort.replace(/\D/g, '').slice(0, 4)" />
          </a-form-model-item>
          <a-form-model-item label="备注" prop="remark">
            <a-textarea v-model="form.remark" placeholder="请输入备注" :rows="3" show-count :maxLength="200" />
          </a-form-model-item>

          <div class="bottom-control">
            <a-space>
              <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
              <a-button type="dashed" @click="cancel">取消</a-button>
            </a-space>
          </div>
        </a-form-model>
      </div>

      <div class="preview-panel">
        <div class="preview-header">实时预览</div>
        <div class="preview-content">
          <iframe
            ref="previewIframe"
            src="https://gdj.shengj.cn/newShare/index.html#/pages/order/drag"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals allow-pointer-lock"
            scrolling="no"
            class="preview-iframe"
          />
        </div>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import { getObj, addObj, putObj } from '@/api/maintenance/homeLayout/index'
import { pickRepairProd } from '../components/RepairProdPicker'
import { pickServiceCategory } from '../components/ServiceCategoryPicker'
import { fetchList as fetchProd } from '@/api/maintenance/product'
import { fetchList as fetchService } from '@/api/maintenance/service'

export default {
  name: 'CreateForm',
  props: {

  },
  data() {
    return {
      open: false,
      showLoading: false,
      submitLoading: false,
      formTitle: '',
      selectedProd: null,
      selectedProdId: '',
      selectedService: null,
      selectedServiceId: '',
      prodCache: [],
      serviceCache: [],
      form: this.initForm(),
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        status: [{ required: true, message: '请选择是否开启', trigger: 'change' }],
        icon: [{ required: true, message: '请上传图标', trigger: 'change' }],
        jumpType: [{ required: true, message: '请选择跳转类型', trigger: 'change' }],
        type: [{ required: true, message: '请选择首页布局', trigger: 'change' }],
        sort: [
          { required: true, message: '请输入排序' },
          { pattern: /^\d{1,4}$/, message: '0-9999之间的整数', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {
    form: {
      handler(newVal) {
        this.sendDataToIframe(newVal)
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    initForm() {
      return {
        id: undefined,
        name: '',
        status: 0,
        icon: '',
        jumpType: 0,
        type: 0,
        sort: 99,
        remark: '',
        objId: '',
      }
    },
    sendDataToIframe(data) {
      const iframe = this.$refs.previewIframe
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(data, '*')
      }
    },
    handleAdd() {
      this.reset()
      this.formTitle = '添加首页布局'
      this.open = true
      this.$nextTick(() => {
        this.sendDataToIframe(this.form)
      })
    },
    handleUpdate(row) {
      this.reset()
      getObj(row.id).then(({ data }) => {
        this.form = Object.assign(this.initForm(), data)
        if (this.form.objId) {
          if (this.form.jumpType === 0) {
            fetchProd({ pageNum: 1, pageSize: 999 }).then(res => {
              this.prodCache = res.data.records
              const hit = res.data.records.find(i => i.id === this.form.objId)
              this.selectedProd = hit || { prodName: '【已删除】' }
              this.selectedProdId = this.form.objId
              this.sendDataToIframe(this.form)
            })
          } else if (this.form.jumpType === 1) {
            fetchService({ pageNum: 1, pageSize: 999, parentId: 0 }).then(res => {
              this.serviceCache = res.data.records
              const hit = res.data.records.find(i => i.id === this.form.objId)
              this.selectedService = hit || { categoryName: '【已删除】' }
              this.selectedServiceId = this.form.objId
              this.sendDataToIframe(this.form)
            })
          }
        }
        this.formTitle = '修改首页布局'
        this.open = true
        this.$nextTick(() => {
          this.sendDataToIframe(this.form)
        })
      })
    },
    handlePick() {
      fetchProd({ pageNum: 1, pageSize: 999 }).then(res => {
        this.prodCache = res.data.records
        pickRepairProd(null, this.selectedProdId).then(p => {
          if (p) this.assignProd(p)
        })
      })
    },
    assignProd(p) {
      this.selectedProd = p
      this.selectedProdId = p.id
      this.form.prodId = p.id
      this.form.objId = p.id
    },
    clearProd() {
      this.selectedProd = null
      this.selectedProdId = ''
      this.form.prodId = undefined
      this.form.objId = ''
    },
    handlePickService() {
      fetchService({ pageNum: 1, pageSize: 999, parentId: 0 }).then(res => {
        this.serviceCache = res.data.records
        pickServiceCategory(this.selectedServiceId).then(s => {
          if (s) this.assignService(s)
        })
      })
    },
    assignService(s) {
      this.selectedService = s
      this.selectedServiceId = s.id
      this.form.serviceId = s.id
      this.form.objId = s.id
    },
    clearService() {
      this.selectedService = null
      this.selectedServiceId = ''
      this.form.serviceId = undefined
      this.form.objId = ''
    },
    handleJumpTypeChange() {
      this.clearProd()
      this.clearService()
    },
    cancel() {
      this.onCloseConfirm(() => (this.open = false))
    },
    onCloseConfirm(cb) {
      this.$confirm({
        title: '是否确认关闭并清空数据？',
        onOk: () => {
          this.reset()
          cb && cb()
        },
      })
    },
    getImg(url, field) {
      this.form[field] = url
      this.$refs.form.clearValidate(field)
    },
    submitForm() {
      this.$refs.form.validate((valid, obj) => {
        if (!valid) {
          const msgs = Object.values(obj).flatMap((v) => v.map((m) => m.message))
          this.showLoading = true
          this.$nextTick(() => this.$refs.LoadingPop.init(2, msgs))
          return
        }
        this.submitLoading = true
        this.showLoading = true
        this.$nextTick(() => this.$refs.LoadingPop.init(1))
        const api = this.form.id ? putObj : addObj
        api(this.form)
          .then(() => {
            this.$message.success(this.form.id ? '修改成功' : '新增成功', 3)
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
            this.showLoading = false
          })
      })
    },
    reset() {
      this.form = this.initForm()
      this.selectedProd = null
      this.selectedProdId = ''
      this.selectedService = null
      this.selectedServiceId = ''
      this.$nextTick(() => this.$refs.form?.clearValidate())
    },
  },
}
</script>

<style lang="less" scoped>
.layout-container {
  display: flex;
  height: 80vh;
  gap: 20px;
}

.setting-panel {
  flex: 1;
  overflow-y: auto;
  padding-right: 10px;
  border-right: 1px solid #f0f0f0;
}

.preview-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
}

.preview-header {
  padding: 16px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  font-weight: bold;
  text-align: center;
}

.preview-content {
  flex: 1;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.preview-iframe {
  width: 375px;
  height: 667px;
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  background: white;
}

.bottom-control {
  text-align: right;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

:deep(.ant-drawer-body) {
  padding: 16px;
  overflow: hidden;
}

:deep(.ant-form-item) {
  margin-bottom: 16px;
}
</style>
